// extracted by mini-css-extract-plugin
export var icon = "_ax-3";
export var subtitle = "_ax-2";
export var title = "_ax-1";
export var value = "_ax-0";